(function() {
    'use strict';

    angular
        .module('sideApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
